<div bsModal #linkedAccountsModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
     aria-hidden="true" [config]="{keyboard: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span class="capitalize-text">{{l("LinkedAccounts")}}</span>
                </h4>
                <button class="btn btn-primary pull-right" (click)="manageLinkedAccounts()"><i class="fa fa-plus"></i>{{l("LinkNewAccount")}}</button>
            </div>
            <div class="modal-body">
                <!--<Primeng-TurboTable-Start>-->
                <div class="primeng-datatable-container"
                     [busyIf]="primengTableHelper.isLoading">
                    <p-table #dataTable
                             (onLazyLoad)="getLinkedUsers($event)"
                             [value]="primengTableHelper.records"
                             rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                             [paginator]="false"
                             [lazy]="true"
                             [responsive]="primengTableHelper.isResponsive">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width:20%">
                                    {{l('Actions')}}
                                </th>
                                <th style="width:65%" pSortableColumn="userName">
                                    {{l('UserName')}}
                                    <p-sortIcon field="userName"></p-sortIcon>
                                </th>
                                <th style="width:15%">
                                    {{l('Delete')}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-record="$implicit">
                            <tr>
                                <td style="width:20%">
                                    <button class="btn btn-sm btn-primary" (click)="switchToUser(record)">
                                        <i class="fa fa-sign-in"></i>{{l('LogIn')}}
                                    </button>
                                </td>
                                <td style="width: 65%">
                                    <span class="ui-column-title"> {{l('UserName')}}</span>
                                    {{getShownLinkedUserName(record)}}
                                </td>
                                <td style="width:15%">
                                    <button class="btn btn-sm btn-danger red" (click)="deleteLinkedUser(record)">
                                        <i class="fa fa-trash" [attr.aria-label]="l('Delete')"></i>
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                        {{l('NoData')}}
                    </div>
                    <div class="primeng-paging-container">
                        <p-paginator rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                                     #paginator
                                     (onPageChange)="getLinkedUsers($event)"
                                     [totalRecords]="primengTableHelper.totalRecordsCount"
                                     [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage">
                        </p-paginator>
                        <span class="total-records-count">
                            {{l('TotalRecordsCount', primengTableHelper.totalRecordsCount)}}
                        </span>
                    </div>
                </div>
                <!--<Primeng-TurboTable-End>-->
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default pull-right" (click)="close()">{{l("Close")}}</button>
            </div>
        </div>
    </div>
</div>
<linkAccountModal #linkAccountModal (modalSave)="getLinkedUsers()"></linkAccountModal>
